<template>
    <div class="vsebina ">
        
    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <sub>E_Obr. 3.21_rev.03</sub>
        <h1>Obnova prijave postopka certificiranja ekoloških kmetijskih gospodarstev (KMG)</h1>
        <h6>v skladu z veljavno zakonodajo za ekološko kmetijstvo</h6>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
  
    <div class="telo_vsebine adapt v-adapt">
            <!--
            <div class="form-group">
                <div class="km-widget km-buttongroup k-widget k-button-group">
                <button  type="button" class="k-button k-primary" @click="saveData" :disabled="!saveEnabled" >Shrani</button>
                <button type="button" class="k-button k-primary" @click="nazaj" >Nazaj</button>
            </div>
            Shrani
            -->
        
            <form @submit.prevent="handleSubmit" class="k-form">
            
                <div class="sekcija podatki">
                    <h1>1. OSNOVNI PODATKI O NOSILCU KMG</h1>

                    <fieldset >

                        <label for="nosilec" class="k-form-field">
                            <span>a) Nosilec KMG:</span>
                        </label>
                        <div class="display-flex">
                            <input disabled type="text" v-model="prijava.kontakt.naziv" name="nosilec" id="nosilec" class="k-textbox" />
                        </div>
                        
                        <label for="ooseba" class="k-form-field">
                            <span>b) Odgovorna oseba nosilca:</span>
                        </label>
                        <div class="display-flex">
                            <input :disabled="!prijavaodprta" type="text" v-model="prijava.odgovornaoseba"  name="ooseba" id="ooseba" class="k-textbox" />
                        </div>
                        
                        <label for="naslov" class="k-form-field">
                            <span>c) Naslov:</span>
                        </label>
                        <div class="display-flex">
                                <input  disabled type="text" v-model="prijava.kontakt.naslov"  name="naslov" id="naslov" class="k-textbox" />
                        </div>
                        
                        <label for="posta" class="k-form-field">
                            <span>d) Poštna številka in pošta:</span>
                        </label>
                        <div class="display-flex posta">
                            <input disabled type="text" v-model="prijava.kontakt.postnastevilka"  name="postnastevilka" id="postnastevilka" class="k-textbox " />
                            <input disabled type="text" v-model="prijava.kontakt.posta"  name="posta" id="nosipostalec" class="k-textbox" />
                        </div>
                        
                        <label for="kmgmid" class="k-form-field">
                            <span>e) KMG-MID:</span>
                        </label>
                            <div class="display-flex">
                            <input disabled type="text" v-model="prijava.kmgmid"  name="kmgmid" id="kmgmid" class="k-textbox" />
                        </div>
                        
                        <label for="telefon" class="k-form-field">
                            <span>f) Telefon:</span>
                        </label>
                        <div class="display-flex">
                            <input  :disabled="!prijavaodprta" type="text" v-model="prijava.kontakt.telefon"  name="telefon" id="telefon" class="k-textbox" />
                        </div>
                        
                        <label for="mobitel" class="k-form-field">
                            <span>g) Mobilni telefon:</span>
                        </label>
                        <div class="display-flex">
                            <input :disabled="!prijavaodprta" type="text" v-model="prijava.telefonoo"  name="mobitel" id="mobitel" class="k-textbox" />
                        </div>
                        
                        <label for="email" class="k-form-field">
                        <span>h) Elektronski naslov:</span>
                        </label>
                        <div class="display-flex">
                            <input :disabled="!prijavaodprta" type="text" v-model="prijava.emailoo"  name="email" id="email" class="k-textbox" />
                        </div>
                        
                        <label for="spletnastran" class="k-form-field">
                            <span>i) Spletna stran KMG:</span>
                        </label>
                        <div class="display-flex">
                            <input :disabled="!prijavaodprta" type="text" v-model="prijava.kontakt.spletnastran"  name="spletnastran" id="spletnastran" class="k-textbox" />
                        </div>
                        
                        <label for="naslovkmg" class="k-form-field">
                            <span>j) Naslov KMG:</span>
                        </label>
                        <div class="display-flex">
                                <input disabled type="text" v-model="prijava.kontakt.naslovkmg"  name="naslovkmg" id="naslovkmg" class="k-textbox" />
                        </div>
                        
                        <label for="postakmg" class="k-form-field">
                            <span>k) Poštna številka in pošta KMG:</span>
                        </label>
                        <div class="display-flex posta">
                            <input disabled type="text" v-model="prijava.kontakt.postnastevilkakmg"  name="postnastevilkakmg" id="postnastevilkakmg" class="k-textbox" />
                            <input disabled type="text" v-model="prijava.kontakt.postakmg"  name="postakmg" id="postakmg" class="k-textbox" />
                        </div>
                        
                        
                        <label for="davcnastevilka" class="k-form-field">
                            <span>l) Davčna številka nosilca KMG:</span>
                        </label>
                        <div class="display-flex">
                            <input disabled type="text" v-model="prijava.davcnastevilka"  name="davcnastevilka" id="davcnastevilka" class="k-textbox" />
                        </div>
                        
                    </fieldset>

                </div>
                    <div class="firstpagespace"></div>
                 <div class="sekcija dejavnosti" >
                    <h1>2. DEJAVNOSTI, ki jih prijavljate v postopek certificiranja </h1>

                    <fieldset class="">
                    <div class="seznamdejavnosti">
                         <template v-for="vrsta in vrsta">
                            <div :key="vrsta.id" style="break-inside: avoid;">
                            <input :disabled="!prijavaodprta" class="k-checkbox" v-model="prijava.dejavnosti" :true-value="vrsta.id"  type="checkbox" :value="vrsta.id" :id="'vrsta_chk_'+vrsta.id">
                            <label class="form-check-label" :for="'vrsta_chk_'+vrsta.id" >
                            {{vrsta.naziv}}
                            </label>
                            </div>
                        </template>
                    </div>

                    </fieldset>
                </div>

                <div class="sekcija kategorije">
                    <h1>3. KATEGORIJE PROIZVODOV, ki jih prijavljate v postopek certificiranja</h1>

                    <fieldset class="">
                    <div class="seznamkategorij">
                         <template v-for="kategorija in kategorije">
                            <div :key="kategorija.id" style="break-inside: avoid;">
                            <input :disabled="!prijavaodprta" class="k-checkbox" v-model="prijava.kategorije"  type="checkbox" :value="kategorija.id" :id="'kat_chk_'+kategorija.id">
                            <label class="form-check-label" :for="'kat_chk_'+kategorija.id" >
                            ({{kategorija.id}}) {{kategorija.naziv}}
                            </label>
                            </div>
                        </template>
                   

                    </div>

                    </fieldset>
                </div>

                <div class="sekcija posebnosti">
                    <h1>4. POSEBNOSTI</h1>

                    <fieldset class="">
                    <div class="seznamkategorij">
                         <template v-for="posebnost in posebnosti">
                            <div :key="posebnost.id" style="break-inside: avoid;">
                            <input :disabled="!prijavaodprta" class="k-checkbox" v-model="prijava.posebnosti" type="checkbox" :value="posebnost.id" :id="'pos_chk_'+posebnost.id">
                            <label class="form-check-label" :for="'pos_chk_'+posebnost.id" >
                            {{posebnost.naziv}}
                            </label>
                            </div>
                        </template>
                    </div>
                 </fieldset>
                 </div>   
                  
                 <div class="sekcija tretjeosebe">
                    <h1>IZVAJANJE DEJAVNOSTI ZA TRETJE OSEBE NA KMG (uslužnostna predelava npr. mletje, luščenje, skladiščenje…)</h1>

                    <fieldset class="">
                    <div class="seznamkategorij">
                        
                         <template v-for="to in tretjeosebe">
                            <div :key="to.id" style="break-inside: avoid;">
                            <input :disabled="!prijavaodprta" class="k-checkbox" v-model="prijava.tretjeosebe" type="checkbox" :value="to.id" :id="'to_chk_'+to.id">
                            <label class="form-check-label" :for="'to_chk_'+to.id" >
                            {{to.naziv}}
                            </label>
                            </div>
                        </template>
                    </div>

                    </fieldset>
                </div>
                <div class="sekcija prva-izjava" style="break-inside: avoid;">
                <div>Izjava:	</div>
                <div>
                Prijavitelj z oddajo obnove prijave potrjujem resničnost in pravilnost podatkov, ter dovoljujem, da IKC UM kot del vsebine prijave dodatno upošteva tudi podatke iz uradnih evidenc (RKG, VOLOS, EIRŽ, registra pridelovalcev  semen…) in podatke po oddani zbirni vlogi glede površin, kultur, živali, ter ostalih informacij vezanih na postopek certificiranja ekološkega kmetijstva. 
            </div>
                </div>


                <div class="sekcija izjava" style="break-inside: avoid;">
                    <div class="izjavaokvir">
            <div>Izvajalec ali pooblaščenec odda prijavo:</div>
            <ul class="seznam">
                <li>elektronsko (s klikom na polje oddaj vlogo) ALI</li>
                <li>prijavni obrazec natisne, ga lastnoročno podpiše in posreduje na IKC UM (scan prijave na e-pošto info@ikc-um.si ali z redno pošto na IKC UM, Pivola 8, SI-2311, Hoče)</li>
</ul>
</div>
<div>
<div class="oddajavloge">
        <div><div style="flex: 1 1 100%;">DATUM</div></div>
        <div class="divider"></div>
        <div><div style="flex: 1 1 100%;">Ime in priimek izvajalca / pooblaščene osebe</div></div>
        <div class="divider"></div>
        <div><div style="flex: 1 1 100%;" class="no-show"><div>Podpis odgovorne osebe</div><div>žig (v kolikor ga uporabljate)</div></div></div>
</div>
<div class="oddajavloge">
<div><div style="flex: 1 1 100%;">{{ prijava.datumoddajeizpis }}</div></div>
<div class="divider"></div>
<div><div style="flex: 1 1 100%;" ><div>{{ prijava.odgovornaoseba }}</div></div></div>
<div class="divider"></div>
<div><div style="flex: 1 1 100%;"></div></div>
</div>

</div>
                </div>

                   

               

            </form>
        </div>
      
    </div>
</template>
<style>

.sekcija.izjava {
    padding: 0;
}
.sekcija.izjava .izjavaokvir{
    padding: 2mm;
}

@media  print {
    @page {
        @top-center { content: "Preliminary edition" }
margin-top: 8mm;
margin-bottom: 8mm;
margin-left: 8mm;
margin-right: 8mm;
size: A4 portrait;


}
.glava_vsebine.adapt.v-adapt{
    margin-top: 0;
    
}
.glava_vsebine h1,.glava_vsebine h6,.glava_vsebine sub{
    color: var(--accent);
}
#wrapper{
    padding-top: 0px;
}

.tisk-noga{
    position: fixed;
    height:5mm;
    bottom: 0mm;
    width:100vw;
    display:flex;
    justify-content: space-between;
}
    .no-show{

    visibility: visible !important;
}
header,.navigation,.menus,.menu{
    display:none;
    visibility:hidden;
}
.no-print{
    visibility:hidden;
}
}
@media  screen {
.tisk-noga{
    display: none;
}

}
.no-show{
    visibility: hidden;
}


.oddajavloge{
    display:flex;
    align-items: stretch;
    border-top: 1px solid var(--accent);

}
.oddajavloge>.divider{
    border-left:1px solid var(--accent);
    flex:1 1 1px;
}
.oddajavloge>div{
    flex:1 1 33%;
    text-align: center;
    display: flex;
    align-items: center;
   
    

}
 label,textarea{
    break-inside: avoid !important;
     
 }

label.k-form-field{
    font-weight:    bold;
    font-size:  0.8em;
    line-height:    0.8em;
    margin-top:2mm;
    margin-bottom:1mm;
}
.posta input:nth-child(1){
    flex-basis: 15%;
    margin-right: 3mm;

}
h6{
    font-size: 0.7em;
}

.sekcija {
    margin-top:5mm;
    border:   1px solid green;
    padding: 2mm;
}

.vrsticapodpisa div {
    flex-basis: 50%;
}

.mt-1 {
	margin-top: 1rem !important;
	}

    .mt-2 {
	margin-top: 2rem !important;
	}
    .seznam{
        padding-left:15px
    }
    ul.seznam > li:before {
  content: "-";
  margin-right: 10px;
  
}
</style>

<script>


import moment from 'moment'
import { mapState, mapActions,mapMutations } from 'vuex'
import { Previewer} from 'pagedjs';
import Vue from 'vue';
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { Checkbox } from "@progress/kendo-vue-inputs";
import { prijavaService } from '../services/prijava.service';
import {store} from '../store/index.js'
export default {
    props:['sezona','pridelovalecid','shema'],
    components: {
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    
    'kendo-checkbox': Checkbox
  },
   data() {
        return {
            prijavaodprta:false,
            prijava:{kontakt:{}},
            posebnosti:[{id:0,naziv:"sočasna ekološka in neekološka pridelava/reja/predelava"},{id:1,naziv:"gobe"},{id:2,naziv:"čebele"},],
            blagovneznamke:[{id:1,naziv:"DEMETER"},{id:2,naziv:"V-Label"},{id:3,naziv:"brez GSO"}],
            tretjeosebe:[{id:1,naziv:"Samo ekološka predelava"},{id:2,naziv:"Samo konvencionalna predelava"},{id:3,naziv:"Ekološka in konvencionalna predelava"},],
            kulture:[],zivali:[],
            vrsta:[],
            status:[],
            pridelava:{},
            pridelovalec:{},
            statuskategorije:[],
            kategorije:[],
            nosilec:"test",
            ooseba:"",
            naslov:"",
            posta:"",
            postnastevilka:"",
            kmgmid:"",
            telefon:"",
            mobitel:"",
            email:"",
            spletnastran:"",
            naslovkmg:"",
            postakmg:"",
            postnastevilkakmg:"",
            dopolnilnadejavnost:"",
            davcnastevilka:"",
            nazivdopolnilnadejavnost:"",
            datumprijave:new Date(),
            sifrant:{}
        }
    },
    computed:{
      kategorijepridelovalca:
        {
           get() {

            let kategorije=this.pridelava?.kategorije
              
                
            if (kategorije){
                return kategorije.map(i=>(i.id));
            }
            else
                return ["a"];

          },
        },
     vrstapridelovalca:
        {
           get() {

            let dejavnost=this.pridelava?.dejavnosti
                  console.log("getting dej")
                console.log(this.pridelava)
            if (dejavnost)
                return dejavnost.map(i=>(i.id));
            else
                return [];

          }
        },
 vrstapridelovalcavse:
        {
           get() {

            let pridelava=this.pridelovalec?.sheme?.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.vsedejavnosti;
            else
                return [];

          }
        },
        proizvodi:
        {
           get() {
            if(!this.certifikat.vsiproizvodi)
              return [];
            else
              return this.certifikat.vsiproizvodi.filter(i=>i.statuspridelkanaziv!='Neekološki').sort(
                (a,b)=>
                {
                  var x=a.vrstapridelkaid-b.vrstapridelkaid;
                  if(x)
                  return x;
                  else
                  {

                    return a.certifikat.localeCompare(b.certifikat);
                  }
                });
            
          },
        }
    
    },
     methods: {

        handleSubmit(e){

          e.preventDefault();
        },
        saveData(e){
        
        prijavaService.saveOne(this.prijava,this.sezona,this.pridelovalecid,"EKO PRI",'prijavaeko_2023').then(
        prijavadata=>{
            store.dispatch('alert/success', "Vloga je bila uspešno oddana. O tem boste obveščeni tudi preko elektronske pošte!", { root: true });
        },
        err=>{
            store.dispatch('alert/error', "Napaka pri oddaji vloge!", { root: true });
        }
        );
       
    
    },
      handleSubmit(e){

      e.preventDefault();
    },
        print() {
                let paged = new Previewer();
                paged.preview();
        },
        naloziPodatke (){

         var thisComp=this;
         prijavaService.loadOne(thisComp.dataSezona.sezona,thisComp.pridelovalecid,"EKO PRI",'prijavaeko_2023').then(
			prijavadata=>{
                thisComp.vrsta=prijavadata.sifrant["vrstapridelovalca"];
                thisComp.status=prijavadata.sifrant["statuspridelovalca"];
                thisComp.kategorije=prijavadata.sifrant["kategorije"];
                let p=prijavadata.pridelovalec;
                thisComp.pridelovalec=p;
                if(prijavadata.prijava){
                    thisComp.prijava=prijavadata.prijava;
                    thisComp.datumzadnjeoddaje=prijavadata.createdAt;
                }
                else
                    thisComp.prijava={kontakt:{}};

            let pridelava=p.sheme.find(s=>s.sezona==thisComp.dataSezona.sezona&&s.shema=="EKO PRI");
            console.log("našel podatke");
            console.log(pridelava);
            //gerki
               

            let kontakt=p?.kontakt?.find(k=>k.vloga=='nosilec kmg');
            let kontaktkmg=p?.kontakt?.find(k=>k.vloga=='kmetija (kmg)');
            if(!kontakt)
                kontakt=p?.kontakt[0];
                thisComp.kontakt=kontakt;
            //let odgovornaoseba=pridelava.osebe[0];
            
            if(!thisComp.prijava.kontakt)
            thisComp.prijava.kontakt=kontakt;
           
            if(!thisComp.prijava.kontakt.naziv)
            thisComp.prijava.kontakt.naziv=kontakt?.naziv;
            if(!thisComp.prijava.kontakt.naslov)
            thisComp.prijava.kontakt.naslov=kontakt?.naslov;
            if(!thisComp.prijava.kontakt.posta)
            thisComp.prijava.kontakt.posta=kontakt?.posta;
            if(!thisComp.prijava.kontakt.postnastevilka)
            thisComp.prijava.kontakt.postnastevilka=kontakt?.postnastevilka;
           
            if(!thisComp.prijava.kontakt.naslovkmg)
            thisComp.prijava.kontakt.naslovkmg=(kontaktkmg?.naslov)?kontaktkmg.naslov:kontakt?.naslov;
            if(!thisComp.prijava.kontakt.postakmg)
            thisComp.prijava.kontakt.postakmg=(kontaktkmg?.posta)?kontaktkmg.posta:kontakt?.posta;
            if(!thisComp.prijava.kontakt.postnastevilkakmg)
                thisComp.prijava.kontakt.postnastevilkakmg=(kontaktkmg?.postnastevilka)?kontaktkmg.postnastevilka:kontakt?.postnastevilka;;


            if(!thisComp.prijava.kontakt.telefon)
            thisComp.prijava.kontakt.telefon=kontakt?.telefon;
            if(!thisComp.prijava.kontakt.email)
            thisComp.prijava.kontakt.email=kontakt?.email;
            if(!thisComp.prijava.kontakt.spletnastran)
            thisComp.prijava.kontakt.spletnastran=kontakt?.spletnastran
            if(!thisComp.prijava.kontakt.spletnatrgovina)
            thisComp.prijava.kontakt.spletnatrgovina=kontakt?.spletnatrgovina
            
            
            
            if(!thisComp.prijava.kmgmid)
            thisComp.prijava.kmgmid=p?.kmgmid;
            
              if(!thisComp.prijava.davcnastevilka)
              thisComp.prijava.davcnastevilka=p?.davcnastevilka;
    
            if(!thisComp.prijava.davcnizavezanec)
            thisComp.prijava.davcnizavezanec=pridelava?.davcnizavezanec;
            if(!thisComp.prijava.pravnaoblika)
            thisComp.prijava.pravnaoblika="Fizična oseba";
            
              if(!thisComp.prijava.odgovornaoseba)
              thisComp.prijava.odgovornaoseba=kontakt?.naziv;
              if(!thisComp.prijava.telefonoo)
              thisComp.prijava.telefonoo=kontakt?.telefon;
              if(!thisComp.prijava.epostaoo)
              thisComp.prijava.emailoo=kontakt?.email;
    
            
              if(!thisComp.prijava.dejavnosti)
              thisComp.prijava.dejavnosti=pridelava?.dejavnosti?.map(i=>(i.id))
              if(!thisComp.prijava.kategorije)
                thisComp.prijava.kategorije=pridelava?.kategorije?.map(i=>(i.id))
              
              if(!thisComp.prijava.posebnosti)
                thisComp.prijava.posebnosti=[];
              if(!thisComp.prijava.tretjeosebe)
                thisComp.prijava.tretjeosebe=[];
              if(!thisComp.prijava.dejavnosti)
                thisComp.prijava.dejavnosti=[];
              if(!thisComp.prijava.kategorije)
                thisComp.prijava.kategorije=[];
              
              
              
              /*
              if(!this.prijava.podrocja){
                this.prijava.podrocja=pridelava.podrocjacertificiranja.reduce( (a,c)=>{
                    if(c.status?.id==1)
                      Vue.set(a,c.naziv,true);
                    else
                        Vue.set(a,c.naziv,false);
                    return a;
                })
              }
            */
            if(!this.prijava.datumoddaje){

                this.prijava.datumoddaje=new Date();
            }
            else
                this.opozorilo="Vlogo ste že oddali";
            
            this.prijava.datumoddajeizpis=moment(this.prijava.datumoddaje).format("DD.MM.YYYY");

            //naloži prijavo od lani...
           
			
			
            
			
            
            
            },
            err=>{
                store.dispatch('alert/error', "Pri nalaganju obstoječe prijave je prišlo do težave!", { root: true });
            }
                        );

                            

                      
                       


                            

            
      
        

        

        
    }                
    

      },
    created()
  {
    
    if(!this.sezona)
        this.dataSezona={sezona:2022};
    else
      this.dataSezona={sezona:this.sezona};

     this.naloziPodatke();
     //window.addEventListener('beforeprint',this.print);
},

  mounted(){
   
 }
}
</script>